import React, { useState } from "react";
import {
  Button,
  Form,
  Image,
  Input,
  Select,
  Space,
  TimePicker,
  notification,
  Upload,
} from "antd";
import { GrUpload } from "react-icons/gr";
import { useNavigate, useParams } from "react-router-dom";

const options = [
  {
    label: "Sunday",
    value: "sunday",
    desc: "Sunday",
  },
  {
    label: "Monday",
    value: "monday",
    desc: "Monday",
  },
  {
    label: "Tuesday",
    value: "tuesday",
    desc: "Tuesday",
  },
  {
    label: "Wednesday",
    value: "wednesday",
    desc: "Wednesday",
  },
  {
    label: "Thrusday",
    value: "thrusday",
    desc: "Thrusday",
  },
  {
    label: "Friday",
    value: "friday",
    desc: "Friday",
  },
  {
    label: "Saturday",
    value: "saturday",
    desc: "Saturday",
  },
];

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const CreateSalons = ({ form, onFinishCreateSalon, setLoading }) => {
  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  return (
    <>
      <section>
        <div className="Create-Category">
          <Form
            layout="vertical"
            className="subscription-form"
            form={form}
            onFinish={onFinishCreateSalon}
          >
            <>{onFinishCreateSalon}</>
            <div className="subscription">
              <Form.Item
                label="Salon Name"
                name="salonName"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the salon name!" },
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "salon name should contain only letters!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter Salon Name" />
              </Form.Item>

              <Form.Item
                label="Salon Owner Name"
                name="ownerName"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the salon owner name!",
                  },
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Owner name should contain only letters!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter Salon Owner Name" />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                label="Aadhar Number"
                name="aadharNumber"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the aadhar number!",
                  },
                  {
                    len: 12,
                    message: "Aadhar number must be exactly 12 digits!",
                  },
                  {
                    pattern: /^[0-9]{12}$/,
                    message: "Aadhar number should contain only numbers!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter Aadhar Number" />
              </Form.Item>

              <Form.Item
                label="Service KM"
                name="serviceKm"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter the service km" },
                  {
                    type: "number",
                    message: "Service KM must be a number",
                    transform: (value) => (value ? Number(value) : undefined),
                  },
                  {
                    pattern: /^[0-9]+$/,
                    message: "Please enter a valid number!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter Service KM" />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                label="Salon Type"
                name="salonType"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select the salon type" },
                ]}
              >
                <Select
                  placeholder="Select Salon Type"
                  style={{
                    marginTop: "0.5rem",
                    width: "99%",
                  }}
                  options={[
                    {
                      value: "0",
                      label: "Men",
                    },
                    {
                      value: "1",
                      label: "Women",
                    },
                    {
                      value: "2",
                      label: "Unisex",
                    },
                  ]}
                />
              </Form.Item>

              <Form.Item
                label="Service Type"
                name="serviceType"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select the service type" },
                ]}
              >
                <Select
                  placeholder="Select The Service Type"
                  style={{
                    marginTop: "0.5rem",
                    width: "99%",
                  }}
                  options={[
                    {
                      value: "0",
                      label: "Home Visit",
                    },
                    {
                      value: "1",
                      label: "Salon Visit",
                    },
                    {
                      value: "2",
                      label: "Both",
                    },
                  ]}
                />
              </Form.Item>
            </div>
            <div className="subscription">
              {/* <Form.Item
                label="Status"
                name="status"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select the status" },
                ]}
              >
                <Select
                  placeholder="Select status"
                  style={{
                    marginTop: "0.5rem",
                    width: "99%",
                  }}

                  options={[
                    {
                      value: "1",
                      label: "Active",
                    },
                    {
                      value: "0",
                      label: "Inactive",
                    },

                    {
                      value: "2",
                      label: "Block",
                    },
                  ]}
                />
              </Form.Item> */}

              <Form.Item
                label="Working Days"
                name="workingDays"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select the working days" },
                ]}
              >
                <Select
                  label="Working Days"
                  name="workingDays"
                  className="subscription-plan"
                  rules={[
                    {
                      required: true,
                      message: "Please select the working days",
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    style={{
                      width: "100%",
                    }}
                    placeholder="Select The Working Days"
                    onChange={handleChange}
                    options={options}
                    optionRender={(option) => (
                      <Space>
                        <span role="img" aria-label={option.data.label}>
                          {option.data.emoji}
                        </span>
                        {option.data.desc}
                      </Space>
                    )}
                  />
                </Select>
              </Form.Item>

              {/* 
              <Form.Item
                label="Working Hours"
                name="workinghours"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please select the working hours",
                  },
                ]}
              >
                <Space wrap>
                  <TimePicker use12Hours format="h:mm A" onChange={onChange} />
                  <TimePicker use12Hours format="h:mm A" onChange={onChange} />
                </Space>
              </Form.Item> */}
            </div>

            {/* <div className="upload-Img">
                         <Form.Item
                           label="Upload Salon Images"
                           name="profileImage"
                           className="subscription-plan"
                           rules={[{ required: true, message: "Please upload the salon images" }]}
                         >
                           <Upload {...props} maxCount={1}
           
                             listType="picture-card"
                             fileList={fileList}
                             className="upload-Img-input"
                             onPreview={handlePreview}
                             onChange={handleImageChange}
                           >
                             {fileList.length >= 8 ? null : uploadButton}
                           </Upload>
                           {previewImage && (
                             <Image
                               wrapperStyle={{ display: "none" }}
                               preview={{
                                 visible: previewOpen,
                                 onVisibleChange: (visible) => setPreviewOpen(visible),
                                 afterOpenChange: (visible) => !visible && setPreviewImage(""),
                               }}
                               src={previewImage}
                             />
                           )}
                         </Form.Item>
                       </div> */}
            <div className="steps-action">
              <Button type="primary" htmlType="submit">
                Next
              </Button>
            </div>
          </Form>
        </div>
      </section>
    </>
  );
};

export default CreateSalons;
